import React from 'react';
import classNames from 'classnames';
import {setState} from './utils';
import {languages} from './langs';
import Main from './Main';
import Advert from './Advert';
import {track, notification, heartbeat} from './tracking';
import xr from './xr';
import moment from 'moment';
import 'moment/locale/hr';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/cs';

window.HEARTBEAT = heartbeat;
window.LAST_ACTIVE = new Date();
window.TRACKING_EVENT = {};
window.FULL_SCREEN_ACTIVE = null;

export class App extends React.Component {

  constructor (props) {
    super(props);
    let [lng, lat] = props.location.coordinates;
    this.state = {
      lang: null,
      gamesSelected: false,
      selected: {
        category: null,
        subcategory: null,
        poi: null,
        extra: null,
        game: null,
      },
      page: 0,
      weather: null,
      map: {
        center: [lat, lng],
        zoom: 14,
      },
    };
    window.APP = this;
    this.initMap = this.state.map;
    this.select = this.select.bind(this);
    this.selectPOI = this.selectPOI.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.selectSubcategory = this.selectSubcategory.bind(this);
    this.selectExtra = this.selectExtra.bind(this);
    this.selectGame = this.selectGame.bind(this);
    this.updateWeather = this.updateWeather.bind(this);
    this.onBodyClick = this.onBodyClick.bind(this);
  }

  componentDidMount () {
    this.updateWeather();

    this.addHomeBannerListeners();

    this.weatherUpdater = setInterval(() => {
      this.updateWeather();
    }, 30*60*1000);

    this.activity = setInterval(() => {
      let now = new Date().getTime(),
          delta = now - window.LAST_ACTIVE.getTime();

      if (delta > 30*1000) { // 30s
        this.setState({
          lang: null,
          gamesSelected: false,
          selected: {
            category: null,
            subcategory: null,
            poi: null,
            extra: null,
            game: null,
          },
          map: this.initMap,
        });
        this.LAST_ACTIVE = new Date();
      }
    }, 5000);

    this.notificationInterval = setInterval(heartbeat, 2*60*1000);

    heartbeat();

    this.updateInterval = setInterval(() => {
      console.info('Check if kiosk should update...');

      xr.get(`/api/update/${this.props['kiosk_id']}/`, {}).then(({data}) => {
        let {time, should_reload} = data;
        if (time > this.props.time) {
          if (should_reload) {
            notification('reload');
            setTimeout(() => {window.location.reload(false)}, 2000);
          }
        }
      }, res => console.error('Failed update check', res));
    }, 2*60*1000);

    notification('load');
  }

  componentWillUnmount () {
    clearInterval(this.activity);
    clearInterval(this.weatherUpdater);
    clearInterval(this.notificationInterval);
    clearInterval(this.updateInterval);
  }

  render () {
    let sponsor = this.getCategorySponsor(), footer = null, splash = null;
    if (sponsor && sponsor.footer) {
      footer = <Advert id="footer" advert={sponsor.footer} loop={true} />;
    }

    if (sponsor && sponsor.splash && sponsor.splash.video) {
      splash = <Advert id="splash" advert={sponsor.splash} />;
    }
    const cls = {App: true, footerAds: footer != null};

    if (this.state.lang != null) cls[`lang-${this.state.lang}`] = true;

    return (
      <div onClick={this.onBodyClick}
           className={classNames(cls)}>
        { splash }
        <Main {...this.props}
              lang={this.state.lang}
              map={this.state.map}
              page={this.state.page}
              selectLanguage={this.selectLanguage.bind(this)}
              category={this.state.selected.category}
              selectedExtra={this.state.selected.extra}
              gamesSelected={this.state.gamesSelected}
              selectedGame={this.state.selected.game}
              subcategory={this.state.selected.subcategory}
              weather={this.state.weather}
              sponsor={sponsor}
              setPage={setState(this, 'page')}
              selectCategory={this.selectCategory}
              selectSubcategory={this.selectSubcategory}
              selectExtra={this.selectExtra}
              selectGame={this.selectGame}
              selected_poi={this.state.selected.poi}
              selectPOI={this.selectPOI}
              updateMap={this.updateMap}
        />
        { footer }
      </div>
    );
  }

  select (item, value) {
    let selected = Object.assign({}, this.state.selected);
    selected[item] = value;
    this.setState({selected});
  }

  selectLanguage (lang) {
    this.setState({lang});
    moment.locale(lang);

    // send message to extra iframe
    let extra = this.state.selected.extra
    if (extra != null) {
      document.getElementById('extra-iframe-' + extra).contentWindow.postMessage({
        type: 'SET_LANGUAGE',
        payload: lang,
      }, '*');
    }
  }

  selectCategory (category) {
    let selected = Object.assign({}, this.state.selected);
    selected.category = category;
    selected.poi = null;
    selected.subcategory = null;

    if (selected.extra != null) {
      document.getElementById('extra-iframe-' + selected.extra).contentWindow.postMessage({
        type: 'RESET',
      }, '*');
    }

    if (selected.game != null) {
      document.getElementById('game-iframe-' + selected.game).contentWindow.postMessage({
        type: 'RESET',
      }, '*');
    }

    selected.game = null;
    selected.extra = null;
    this.setState({gamesSelected: false, selected, page: 0});
  }

  selectExtra (extraId) {
    document.getElementById('extra-iframe-' + extraId).contentWindow.postMessage({
      type: 'SET_LANGUAGE',
      payload: this.state.lang,
    }, '*');

    if (this.state.selected.game != null) {
      document.getElementById('game-iframe-' + this.state.selected.game).contentWindow.postMessage({
        type: 'RESET',
      }, '*');
    }

    this.setState({gamesSelected: false, selected: {
        category: null,
        subcategory: null,
        poi: null,
        extra: extraId,
        game: null,
    }, page: 0});
  }

  selectGame (gameId) {
    if (gameId != null) {
      document.getElementById('game-iframe-' + gameId).contentWindow.postMessage({
        type: 'SET_LANGUAGE',
        payload: this.state.lang,
      }, '*');
    };

    if (this.state.selected.extra != null) {
      document.getElementById('extra-iframe-' + this.state.selected.extra).contentWindow.postMessage({
        type: 'RESET',
      }, '*');
    }

    this.setState({gamesSelected: true, selected: {
        category: null,
        subcategory: null,
        poi: null,
        extra: null,
        game: gameId,
    }, page: 0});
  }

  selectSubcategory (subcat) {
    let selected = Object.assign({}, this.state.selected);
    selected.subcategory = subcat;
    selected.poi = null;
    this.setState({selected});
  }

  selectPOI (poi) {
    this.select('poi', poi); 
    this.updateMap({center: poi.location});
  }

  getCategorySponsor() {
    let id = this.state.selected.category;
    return this.props.category_sponsor.find(cat => cat.poi_category_id === id);
  }

  updateMap = map => {
    window.LAST_ACTIVE = new Date();
    map = {...this.state.map, ...map};
    this.setState({map});
  }

  updateWeather () {
    let q = this.props.kiosk_group.weather_query;
    if (q === '') return;

    const icons = {
      '01': 'clear',
      '02': 'fewclouds',
      '03': 'fewclouds',
      '04': 'clouds',
      '09': 'rain',
      '10': 'rain',
      '11': 'rain',
      '13': 'snow',
      '50': 'clear', // mist!
    }
    const BASE_URL = 'http://api.openweathermap.org/data/2.5/';
    const KEY = 'fb3f6801e71f2ca70a6ab4d773e2ad1f';

    xr.configure({
      headers: {
        'Accept': 'application/json',
        //'Content-Type': 'application/json', // Weather API didn't allow Content-Type
      },
    });

    let now  = xr.get('/proxy/', {url: `${BASE_URL}weather?q=${q}&mode=json&units=metric&APPID=${KEY}`}),
        next = xr.get('/proxy/', {url: `${BASE_URL}forecast/daily?q=${q}&mode=json&units=metric&cnt=4&APPID=${KEY}`}),
        all  = Promise.all([now, next]);
    all.then(([now, next]) => {
      if (now == null || !now.weather || !now.main) return;

      let weather = [];
      weather.push({
        icon: icons[now.weather[0].icon.substr(0,2)],
        temp: now.main.temp,
        time: now.dt*1000,
      });

      if (!next.list) return;
      next.list.splice(1).forEach(w => {
        if (!w.weather) {
          weather.push(null);
          return;
        }
        weather.push({
          icon: icons[w.weather[0].icon.substr(0,2)],
          temp: w.temp.day,
          time: w.dt*1000,
        });
      });
      this.setState({weather});
    }).catch(reason => console.error('Cannot update weather', reason));
  }

  addHomeBannerListeners() {
    var homebanners = document.getElementsByClassName('homebanner');
    Array.prototype.forEach.call(homebanners, el => {
      const id = el.getAttribute('data-id'),
            fullscreen = el.getAttribute('data-fullscreen'),
            extra = el.getAttribute('data-extra');

      el.addEventListener('click', event => {
        if (extra) {
          let e = this.props.extra.find(e => e.code = extra);
          // TODO doesn't work yet!
          if (e != null) {
            this.setState({selected: Object.assign({}, this.state.selected, {
              extra: e.extra_content_id,
            })});
          }
        } else if (fullscreen) {
          track({
            event: 'home_banner',
            x: event.clientX,
            y: event.clientY,
            source: 'none',
            target_id: null,
            language: this.state.lang,
          });

          document.getElementById('fullscreen').style.display = 'inherit';
          let full = document.getElementById('full-iframe-' + id);
          full.style.display = 'inherit';
          full.contentWindow.postMessage({
            type: 'START',
          }, '*');
          window.FULL_SCREEN_ACTIVE = id;
        }
      });
    });


    setInterval(() => {
      // check if full screen is active and there is no activity for X seconds
      let now = new Date().getTime(),
          delta = now - window.LAST_ACTIVE.getTime();

      if (delta > 1*60*1000 && window.FULL_SCREEN_ACTIVE != null) { // 1 minute
          let full = document.getElementById('full-iframe-' + window.FULL_SCREEN_ACTIVE);
          full.contentWindow.postMessage({
            type: 'END',
          }, '*');
          document.getElementById('fullscreen').style.display = 'none';
          full.style.display = 'none';
          window.FULL_SCREEN_ACTIVE = null;
          track({
            event: 'fullscreen_timeout',
            source: 'none',
          });
      }
    }, 1000);
  }

  onBodyClick (e) {
    track({
      event: 'click',
      x: e.clientX,
      y: e.clientY,
      source: 'none',
      target_id: null,
      language: this.state.lang,
      selected_category_id: this.state.selected.category,
    });
  }
}

function iframeUrl(url) {
  if (url.startsWith('/') && process.env.NODE_ENV === 'development') {
    return 'https://interaktivno.go2digital.hr' + url;
  }
  return url;
}

export function addIframes(extra, games, homepageIframes) {
  let iframes = document.getElementById('iframes');

  extra.forEach(ex => {
    let iframe = document.createElement('iframe');
    iframe.setAttribute('src', iframeUrl(ex.url));
    iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin');
    iframe.setAttribute('id', 'extra-iframe-' + ex.extra_content_id);
    iframe.style.display = 'none';
    iframes.appendChild(iframe);
  });

  games.forEach(ex => {
    let iframe = document.createElement('iframe');
    iframe.setAttribute('src', iframeUrl(ex.url));
    iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin');
    iframe.setAttribute('id', 'game-iframe-' + ex.kiosk_game_id);
    iframe.style.display = 'none';
    iframes.appendChild(iframe);
  });

  homepageIframes.forEach(banner => {
    let iframe = document.createElement('iframe'),
        iframeCover = document.createElement('div');

    iframe.setAttribute('src', iframeUrl(banner.iframe_url));
    iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin');
    iframe.setAttribute('id', 'homepage-iframe-' + banner.home_banner_id);

    iframeCover.setAttribute('class', 'homebanner');
    iframeCover.setAttribute('data-id', banner.home_banner_id);
    iframeCover.setAttribute('data-name', banner.name);
    iframeCover.setAttribute('data-fullscreen', banner.full_screen_iframe_url);
    iframeCover.setAttribute('data-extra', banner.extra_content);

    iframe.style.height = iframeCover.style.height = banner.height + 'px';
    iframe.style.top = iframeCover.style.top = banner.top + 'px';
    iframe.style.position = iframeCover.style.position = 'absolute';
    iframe.style.width = iframeCover.style.width = '1080px';
    iframe.style.zIndex = '100';
    iframeCover.style.zIndex = '101';
    iframeCover.style.background = 'rgba(0,0,0,0)';

    document.getElementById('homebanners').appendChild(iframe);
    if (banner.full_screen_iframe_url || banner.extra_content) {
      // take over click if one of those attr is defined
      document.getElementById('homebanners').appendChild(iframeCover);
    }

    if (banner.full_screen_iframe_url) {
      let fullIframe = document.createElement('iframe');
      fullIframe.setAttribute('src', iframeUrl(banner.full_screen_iframe_url));
      fullIframe.setAttribute('sandbox', 'allow-scripts allow-same-origin');
      fullIframe.setAttribute('id', 'full-iframe-' + banner.home_banner_id);
      fullIframe.style.top = '0';
      fullIframe.style.display = 'none';
      fullIframe.style.position = 'absolute';
      fullIframe.style.zIndex = '110';
      fullIframe.style.width = '1080px';
      fullIframe.style.height = '1920px';
      document.getElementById('fullscreen').appendChild(fullIframe);
    }
  });
}

export function prepareProps (props) {
  // add category/subcategory to each poi
  props.categories.forEach(cat => {
    // map all subcategories
    let subcats = {};
    if (cat.subcategories) {
      cat.subcategories.forEach(subcat => {
        subcats[subcat.poi_subcategory_id] = subcat;
        subcat.poi_category = cat;
      });
    }

    cat.poi.forEach(poi => {
      poi.poi_category = cat;
      if (poi.poi_subcategory_id) {
        poi.poi_subcategory = subcats[poi.poi_subcategory_id];
      } else {
        poi.poi_subcategory = null;
      }
    });
  });

  props.languages = languages;
  return props;
}

document.body.addEventListener('mousedown', () => {
  window.LAST_ACTIVE = new Date();
});

window.addEventListener('message', function ({data}) {
  if (data.type === 'ACTIVITY') {
    window.LAST_ACTIVE = new Date();
  } else if (data.type === 'APP_END') {
    track({
      event: 'fullscreen_end',
      source: 'none',
    });
    document.getElementById('fullscreen').style.display = 'none';
    document.getElementById('full-iframe-' + window.FULL_SCREEN_ACTIVE).style.display = 'none';
    window.FULL_SCREEN_ACTIVE = null;
  }
});


document.addEventListener("visibilitychange", function() {
  if (document.visibilityState === 'hidden') {
    notification('unfocus');
  }
});

